import React, { useState, useContext, useEffect } from 'react';
import { ReportExportContext } from './ReportExportContext';
import PictureAsPdfOutlined from '@mui/icons-material/PictureAsPdfOutlined';
import ActionButton from '../../ActionButton';
import ExportReportDialog from './ExportReportDialog';
import { fetchReportExportData } from './fetchReportExportData';
import { exportManagementReport } from './managementReportPDF';

// Fetch only when exporting; existing table exports and on-screen filters remain independent.
export default function ManagementReportExport({ filters, isDark }) {
  const [scope, setScope] = useState(null);
  const { disabled, summary } = useContext(ReportExportContext);
  useEffect(() => { if (disabled) setScope(null); }, [disabled]);
  const loadRows = async range => {
    const report = await fetchReportExportData({ days: 'orders-by-day', hours: 'orders-heatmap',
      items: 'items-summary', timings: 'orders-bump-minutes', tickets: 'orders-list', hierarchy: 'hierarchy' }, scope, range);
    return { rows: [...report.days, ...report.tickets, ...report.items], report: { ...report, filters: scope } };
  };
  return <>
    <ActionButton disabled={disabled} variant="outlined" startIcon={<PictureAsPdfOutlined />} onClick={() => setScope({ ...filters })}>Management Report</ActionButton>
    {scope && !disabled && <ExportReportDialog format="pdf" title="Management Report" defaultFileName="Management-report"
      initialDates={scope} isDark={isDark} onClose={() => setScope(null)} loadRows={loadRows}
      scopeSummary={summary}
      exportPDF={exportManagementReport}
      />}
  </>;
}
